import { Component } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { Identity } from '@sdbn/appclient';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { TransportExternalInformationsGroup } from '../transport-external-informations.model';

@Component({
  selector: 'app-transport-external-informations',
  templateUrl: './transport-external-informations.component.html',
  styleUrls: ['./transport-external-informations.component.scss']
})
export class TransportExternalInformationsComponent extends AbstractWidgetComponent {

  transportId: number;

  transportExternalInformationsGroups = new Array<TransportExternalInformationsGroup>();

  constructor(public translationService: TranslationService, private httpService: HttpService) {
    super();
  }

  onContextChange(contextChange: ContextChange) {
    try {
      if (contextChange.key === 'selected-transport') {
        const selectedTransport = this.dashboardContext.context.get('selected-transport');
        if (selectedTransport != null && selectedTransport.id != null && selectedTransport.id !== this.transportId) {
          this.transportId = selectedTransport.id;
          this.loadExternalInformations();
        }
      }

      if (contextChange.key === 'transport-changed') {
        if (this.transportId != null) {
          this.loadExternalInformations();
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  onSetElementAndContext() {
    const transport = this.dashboardContext.context.get('selected-transport');
    if (transport != null && transport.id != null) {
      this.transportId = transport.id;
      this.loadExternalInformations();
    }
  }

  private loadExternalInformations() {
    const identity = new Identity();
    identity.id = this.transportId;
    this.httpService.postWithContext<TransportExternalInformationsGroup[]>(environment.transportDetailsEndpoint + '/transport-externalinformations', identity).subscribe(
      response => {
        const groups = new Array<TransportExternalInformationsGroup>();
        if (response != null) {
          for (const elm of response) {
            groups.push(new TransportExternalInformationsGroup(elm));
          }
        }
        this.transportExternalInformationsGroups.push(...groups);
      }
    );
  }


}
